import { Tab } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledTabProps {
    label: string;
}

const StyledTab = styled((props: StyledTabProps) => <Tab disableRipple {...props} />)(() => ({
    // fontSize: theme.typography.pxToRem(13),
    color: '#f2f2f2',
    '&.Mui-selected': {
        color: '#ffc107'
    }
}));

export default StyledTab;
